import React, { useEffect, useState } from "react";
import excelIcon from "../../../assets/Icons/excel_Icon.svg";
import { Tooltip } from "@mui/material";
import { getExportReportUrl } from "../../../services/DashboardServices";
import downloadingIcon from "../../../assets/Gifs/Downloading.gif";

const ExcelButton = ({ data }) => {
  const [downloading, setDownloading] = useState(false);
  useEffect(() => {
    console.log("pdfButton", data);
  }, [data]);
  const getExcelUrlHandler = (sessionId) => {
    getExportReportUrl(sessionId).then((res) => {
      if (res && res.data && res.data.data) {
        console.log(res.data.data);
        const a = document.createElement("a");
        a.href = res.data.data;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(res.data.data);
        setDownloading(false);
      } else {
        setDownloading(false);
      }
    });
  };
  return (
    <>
      {!downloading && (
        <div>
          <Tooltip title="Export data to Excel">
            <img
              src={excelIcon}
              alt=""
              onClick={() => {
                setDownloading(true);
                getExcelUrlHandler(data.encrypted_session_id);
              }}
            />
          </Tooltip>
        </div>
      )}
      {downloading && (
        <div>
          <Tooltip
            title="
          Downloading Excel File 
          "
          >
            <img src={downloadingIcon} className="w-6 h-6" alt="" />
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default ExcelButton;
